import { useRef, useState } from "react";
import { Icon } from "semantic-ui-react";
import isEmpty from "./isEmpty";
import "./style.css";

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 500;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / 1024);

const FileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInKBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  labelFiles,
  fileUpdateIconState,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  const [files, setFiles] = useState({});

  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (convertBytesToKB(file.size) < maxFileSizeInKBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }
  };

  // const removeFile = (fileName) => {
  //   delete files[fileName];
  //   setFiles({ ...files });
  //   callUpdateFilesCb({ ...files });
  // };

  return (
    <>
      <div>
        <section className="FileUploadContainer">
          <label className="InputLabel">{label}</label>
          <Icon name="upload" size="huge" />
          <p></p>
          <p>Haz click o arrastra tus archivos aquí</p>
          <input
            className="FormField"
            type="file"
            ref={fileInputField}
            onChange={handleNewFileUpload}
            title=""
            value=""
            {...otherProps}
          />
        </section>
      </div>

      {!isEmpty(files) && (
        <div className="ImagePreview">
          <h4>{labelFiles}</h4>
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];
            return (
              <div>
                <p>
                  Archivo: {file.name} ({convertBytesToKB(file.size)} KB){" "}
                  <Icon
                    name={fileUpdateIconState.icon}
                    size={fileUpdateIconState.size}
                    loading={fileUpdateIconState.loading}
                    color={fileUpdateIconState.color}
                  />{" "}
                  {fileUpdateIconState.message}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default FileUpload;
